<div class="hero-container">
  <div class="sectio">
    <div class="is-hero-categories">
      <swiper #swiperHero [config]="config" class="static-img-desktop">
        <ng-template swiperSlide *ngFor="let item of items">
          <img [src]="item.imgUrl" class="banner" alt="banner">
        </ng-template>
      </swiper>
      <swiper #swiperHero [config]="config" class="static-img-mobile">
        <ng-template swiperSlide *ngFor="let item of itemsMobile">
          <img [src]="item.imgUrlMobile" class="banner" alt="banner">
        </ng-template>
      </swiper>
    </div>
  </div>

  <div class="sorteosLoader loader" *ngIf="loadingBenefits">
    <img src="assets/images/logo-borde-gris.svg" class="brand-shell loader">
  </div>
  <div class="section is-search-bar" *ngIf="!loadingBenefits">
    <div class="search-container">
      <div class="search-input">
        <form (submit)="applyKeywordFilter()">
          <img class="mobileMenu" [src]="assetUrl('assets/images/burger.svg')" (click)="showMobileFilter()">
          <div class="form-group">
            <input [value]="keywords" (keyup)="changeKeywordFilter($event)" class="form-control" placeholder="Buscar Beneficios">
          </div>
          <button class="btn btn-primary">Buscar</button>
        </form>
      </div>
    </div>
  </div>
  <div class="section is-filters" *ngIf="!loadingBenefits">
    <div class="container is-filters">
      <div class="col-2">
        <app-benefits-filter [festividades]="true" [ngClass]="showFilterMobile ? 'show' : ''"></app-benefits-filter>
      </div>
      <div class="col-9">
        <section class="benefits">
          <div class="sort-container">
            <ul *ngIf="toggle" class="thumb-benefits col-6">
              <ng-container *ngIf="!loadingBenefits">
                <p class="noBenefitsText" *ngIf="displayedBenefits.length == 0">{{ waitText }}</p>
                <li *ngFor="let item of displayedBenefits" class="wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
                  <app-benefit-box [item]="item"></app-benefit-box>
                </li>
              </ng-container>
            </ul>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>
